import React, { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { 
	RCCButton, 
	RCCGrid, 
	RCCRefModalProps,
	RCCTooltip
} from "react-common-components";
import { IForwardPagination } from "react-common-components/dist/components/Pagination/interface";
import { useForm } from "react-hook-form";
import FiltersContainer from "src/components/FiltersContainer";
import LovIndicatorFieldsOnLogs from "src/components/Lov/IndicatorFieldsOnLogs";
import { ModalCenter } from "src/components/Modal/styles";
import Pagination from "src/components/Pagination";
import { useTranslation } from "src/context/Translations/context";
import Modal from "../../../components/Modal";
import { IRefLogErrorsModal } from "./interface";

const ImportLogsErrorsModal: React.ForwardRefRenderFunction<IRefLogErrorsModal> = (_,ref) => { 

	const paginationRef = useRef<IForwardPagination>(null);
	const {translate,currentLanguage} = useTranslation();
	const [filters,setFilters] = useState<{logId?:number,fields:string}>();
	const [showFilters,setShowFilters] = useState<boolean>(false);
	const modalref = useRef<RCCRefModalProps>(null);

	const actionButtonOpen=(logId:number) => {
		setFilters({logId,fields:""});
		setShowFilters(false);
		resetFilters();
		modalref.current?.openModal();
	};

	useImperativeHandle(ref, () => ({
		actionButtonOpen
	}));

	const {
		control:controlFilters,
		reset:resetFilters,
		handleSubmit:handleSubmitFilters
	}= useForm();
    
	const submitFilters = async(data:any) => {
		
		setFilters((prevState) => {
			let fields = "";
			if(data.logFields){
				fields = data.logFields?.map((x:any) => x.value).join(",");
			}
			return {...prevState,fields};
		} );

		paginationRef.current?.reload();
	};

	return (
		<Modal
			ref={modalref}
			header={{
				title: translate("Mensagens dos logs de importação"),
				icon: {
					name: "exclamationCircle"
				}
			}}
			footer= {{
				showSaveButton: false,
				cancelButtonText: translate("Fechar")
			}}
			withoutForm
			styleInline={ModalCenter}
		>
					
			<RCCGrid item container styleInline="padding-bottom:50px;">
				<RCCGrid item container justifyContent="flex-end">
					<RCCTooltip
						text={translate("Filtros")}
						color={showFilters || filters?.fields  ? "blue" : "grey"}
						position="left"
					>
						<RCCButton
							icon={{name: "filter", color: "#FFF", size: 16}}
							color={showFilters || filters?.fields ? "blue" : "grey"}
							layout="isRounded"
							size="md"
							onClick={() => setShowFilters((prevState) => !prevState)}
						/>
					</RCCTooltip>
				</RCCGrid>	 
				<FiltersContainer
					onSubmitFilters={handleSubmitFilters(submitFilters)}
					resetFilters={
						() => resetFilters()
					}
					showFilters={showFilters}
				>
					<RCCGrid
						container
						item
					>
						<LovIndicatorFieldsOnLogs
							control={controlFilters}
							name="logFields"
							label={translate("Campos")}
							isClearable
							isMulti
							extraParametersOnLoad={{LogId:filters?.logId}}
						/> 
					</RCCGrid>
				</FiltersContainer>

				{/* List */}
				<Pagination 
					ref={paginationRef}
					dataOrRoute="IndicatorsValues/ListLogsErrors"
					filtersData={filters}    
					styleInline={{header:"flex-wrap: wrap;"}}
					columns={[
						{
							idColumn: "iql002Datahora",
							nameColumn: translate("Data e hora"),
							sm: 3,
							md: 2,
							type: "date",
							format:{date:currentLanguage === "pt" ? "dd/MM/yyyy HH:mm":"MM/dd/yyyy HH:mm"}
						},
						{
							idColumn: "iql002Codcampo",
							nameColumn: translate("Campo"),
							xs:1,
							sm: 2
						},
						{
							idColumn: "iql002Codperiodo",
							nameColumn: translate("Período"),
							xs:1,
							sm: 2,
							type: "string"
						},
						{
							idColumn: "iql002Valor",
							nameColumn: translate("Valor"),
							xs:1,
							sm: 2
						},
						{
							idColumn: "iql002Observacao",
							nameColumn: "",
							xs:1,
							sm:11
						},
						{
							idColumn: "",
							nameColumn: "",
							xs: 1
						}]}
				/>
			</RCCGrid>	
		</Modal>
	);
};

export default forwardRef(ImportLogsErrorsModal);
